module.exports = __webpack_public_path__ + "img/Page2A.c871610e.jpg";